import type { FC } from "react";

import { highlightParts } from "../readerText";

/** `text` with the query's terms marked. */
export const Highlighted: FC<{ text: string; terms: string[] }> = ({
  text,
  terms
}) => (
  <>
    {highlightParts(text, terms).map((part, i) =>
      part.hit ? (
        <mark key={i} className="rounded-xs bg-warn-soft text-fg">
          {part.text}
        </mark>
      ) : (
        <span key={i}>{part.text}</span>
      )
    )}
  </>
);
